export const isLoading = (() => {

    return (state) => {
        const wrapper = document.querySelector('.is-loading');
        if (!wrapper) return;

        if (state) {
            wrapper.classList.add('active');
        } else {
            wrapper.classList.remove('active');
        }
    };
})();
